import { createFileRoute } from "@tanstack/react-router";

import PrivacyPolicy from "@/containers/PrivacyPolicy";

export const Route = createFileRoute("/privacy-policy")({
  component: () => <PrivacyPolicy />,
});
